import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Button, Text} from '@chakra-ui/react3'
import {ShoppingCartIcon} from '../../../../../leap/components/icons'

const AddToCartBtn = ({product, label, showLabel = true, onClick, isLoading, ...props}) => {
    const {formatMessage} = useIntl()
    const addToCartLabel =
        label ||
        formatMessage({
            id: 'product_view.button.add_to_cart',
            defaultMessage: 'Add to Cart'
        })

    return (
        <Button
            variant="primaryFilled"
            size="lg"
            onClick={onClick}
            aria-label={addToCartLabel}
            isLoading={isLoading}
            isDisabled={isLoading}
            {...props}
        >
            {showLabel && <Text>{addToCartLabel}</Text>}
            <ShoppingCartIcon color="icons.on-color" />
        </Button>
    )
}

AddToCartBtn.propTypes = {
    product: PropTypes.object,
    label: PropTypes.string,
    showLabel: PropTypes.bool,
    onClick: PropTypes.func,
    isLoading: PropTypes.bool
}

export default AddToCartBtn
